import { measuredUsingConfigFor as wrap } from 'Components/Worksheets/Core/Helpers/configHelpers';

const getMeasuredUsingConfig = (prefix: string) => {
  const compactionBalance = wrap(`${prefix}.Equipment.CompactionBalance`);
  return {
    [`${prefix}.Equipment.MouldMass`]: compactionBalance,
    [`${prefix}.TestPortions.MouldMass`]: compactionBalance,
    [`${prefix}.TestPortions.PortionMass`]: compactionBalance,
    [`${prefix}.TestPortions.WetSoilAndMouldMass`]: compactionBalance,
    [`${prefix}.TestPortions.PortionMassAfterWaterAdded`]: compactionBalance,
  };
};

export default getMeasuredUsingConfig;
